<template>
  <div class="my-desired-job-profile-section overflow-hidden h-100 w-100">
    <div class="ico-icon-container pb-4">
      <div class="ico-block-label d-inline-flex align-items-center p-1 px-2">
        <span>Ideal Career Opportunity</span>
      </div>
      <div class="help-circle">
        <i class="mdi mdi-information-outline clickable" @click="onClick" />
      </div>
    </div>
    <div class="pb-2">
      Your ideal job terms include…
    </div>
    <div
      class="mt-2 mt-md-0 bottom-0 w-100 overflow-scroll-y-auto scroll-container-top-position"
    >
      <slot />
    </div>

    <ico-study-faq-modal
      :visible="isPopupVisible"
      @modal-close="isPopupVisible = false"
    />
  </div>
</template>

<script>
import IcoStudyFaqModal from '@/components/study/form/ico-question/IcoStudyFaqModal';

export default {
  name: 'MyDesiredJobProfileSection',
  components: {
    IcoStudyFaqModal,
  },
  data: function () {
    return {
      isPopupVisible: false,
    };
  },
  methods: {
    onClick: function () {
      this.isPopupVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables_mixins';
.scroll-container-top-position {
  top: 35px;
}
.ico-block-label {
  background: #EBEEEE 0 0 no-repeat padding-box;
  border: 1px solid #4F5858;
  border-radius: 20px;
  text-align: left;
  font: normal normal 550 14px/16px;
  letter-spacing: 0;
  color: #4F5858;
  opacity: 1;
  height: max-content;
}
.ico-icon-container {
  display: flex;
  justify-content: space-between;
}
.help-circle {
  margin-top: 0;
}
.my-desired-job-profile-section {
  padding-top: 40px;
}
</style>
